import React from "react";
import { Spinner } from "@opendate-app/setlist";
import "./classesShared.css";

export default function ClassesLoading() {
  return (
    <div className="classes-loading">
      <Spinner size="md" />
    </div>
  );
}
